export const SET_IS_LOGIN = 'SET_IS_LOGIN';
export const SET_LOADING_LOGIN = 'SET_LOADING_LOGIN';
export const SET_LOADED_LOGIN = 'SET_LOADED_LOGIN';
export const SET_IS_SHOW_TWO_FACTOR = 'SET_IS_SHOW_TWO_FACTOR';
export const SET_VERIFY_EMAIL = 'SET_VERIFY_EMAIL';

export const CLIENT_ID_CONFIG = 'CLIENT_ID_CONFIG';
export const VUZ_ID_CONFIG = 'VUZ_ID_CONFIG';
export const API_DOMAIN_AUTH_CONFIG = 'API_DOMAIN_AUTH_CONFIG';
export const API_DOMAIN_VIKON_CONFIG = 'API_DOMAIN_VIKON_CONFIG';
export const API_DOMAIN_FILEMANAGER_CONFIG = 'API_DOMAIN_FILEMANAGER_CONFIG';
export const VUZ_NAME_CONFIG = 'VUZ_NAME_CONFIG';

export const DIGITAL_PROFILE_SETTINGS = 'DIGITAL_PROFILE_SETTINGS';
export const DIGITAL_PROFILE_CABINET_LOADED = 'DIGITAL_PROFILE_CABINET_LOADED';

export const PROFILE_BASIC = 'PROFILE_BASIC';
export const MAILING_REGION = 'MAILING_REGION';
export const MAILING_TOWN_TYPE = 'MAILING_TOWN_TYPE';
export const LOADING_PROFILE_BASIC = 'LOADING_PROFILE_BASIC';
export const LOADED_PROFILE_BASIC = 'LOADED_PROFILE_BASIC';

export const SCHEME_IDENTITY_DOCUMENT = 'SCHEME_IDENTITY_DOCUMENT';
export const IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT';
export const LOADING_IDENTITY_DOCUMENT = 'LOADING_IDENTITY_DOCUMENT';
export const LOADED_IDENTITY_DOCUMENT = 'LOADED_IDENTITY_DOCUMENT';

export const TYPES_EDUCATION_DOCUMENTS = 'TYPES_EDUCATION_DOCUMENTS';
export const SCHEMES_EDUCATION_DOCUMENTS = 'SCHEMES_EDUCATION_DOCUMENTS';
export const EDUCATION_DOCUMENTS = 'EDUCATION_DOCUMENTS';
export const LOADING_EDUCATION_DOCUMENTS = 'LOADING_EDUCATION_DOCUMENTS';
export const LOADED_EDUCATION_DOCUMENTS = 'LOADED_EDUCATION_DOCUMENTS';

export const TYPES_EGE_RESULTS = 'TYPES_EGE_RESULTS';
export const SCHEMES_EGE_RESULTS = 'SCHEMES_EGE_RESULTS';
export const EGE_RESULTS = 'EGE_RESULTS';
export const LOADING_EGE_RESULTS = 'LOADING_EGE_RESULTS';
export const LOADED_EGE_RESULTS = 'LOADED_EGE_RESULTS';

export const TYPES_EGE_DOCUMENTS = 'TYPES_EGE_DOCUMENTS';
export const SCHEMES_EGE_DOCUMENTS = 'SCHEMES_EGE_DOCUMENTS';
export const EGE_DOCUMENTS = 'EGE_DOCUMENTS';
export const LOADING_EGE_DOCUMENTS = 'LOADING_EGE_DOCUMENTS';
export const LOADED_EGE_DOCUMENTS = 'LOADED_EGE_DOCUMENTS';

export const TYPES_ACHIEVEMENTS = 'TYPES_ACHIEVEMENTS';
export const SCHEMES_ACHIEVEMENTS = 'SCHEMES_ACHIEVEMENTS';
export const ACHIEVEMENTS = 'ACHIEVEMENTS';
export const LOADING_ACHIEVEMENTS = 'LOADING_ACHIEVEMENTS';
export const LOADED_ACHIEVEMENTS = 'LOADED_ACHIEVEMENTS';

export const TYPES_PRIVILEGES = 'TYPES_PRIVILEGES';
export const SCHEMES_PRIVILEGES = 'SCHEMES_PRIVILEGES';
export const PRIVILEGES = 'PRIVILEGES';
export const LOADING_PRIVILEGES = 'LOADING_PRIVILEGES';
export const LOADED_PRIVILEGES = 'LOADED_PRIVILEGES';

export const TYPES_OTHER_DOCUMENTS = 'TYPES_OTHER_DOCUMENTS';
export const SCHEMES_OTHER_DOCUMENTS = 'SCHEMES_OTHER_DOCUMENTS';
export const OTHER_DOCUMENTS = 'OTHER_DOCUMENTS';
export const LOADING_OTHER_DOCUMENTS = 'LOADING_OTHER_DOCUMENTS';
export const LOADED_OTHER_DOCUMENTS = 'LOADED_OTHER_DOCUMENTS';

export const ZAJAVLS = 'ZAJAVLS';
export const SPR_COMPETITIONS_ZAJAVLS = 'SPR_COMPETITIONS_ZAJAVL';
export const SPR_ALLOWED_FOR_ADMISSION_COMP_GROUPS_NAMES = 'SPR_ALLOWED_FOR_ADMISSION_COMP_GROUPS_NAMES';
export const CONTEST_DIALOG_OPEN_ZAJAVLS = 'CONTEST_DIALOG_OPEN_ZAJAVLS';
export const CONTEST_EDIT_FORM_ZAJAVLS = 'CONTEST_EDIT_FORM_ZAJAVLS';
export const ZAJAVL_EDIT_UUID_ZAJAVLS = 'ZAJAVL_EDIT_UUID_ZAJAVLS';
export const LOADING_ZAJAVLS = 'LOADING_ZAJAVLS';
export const ALLOWED_ONLINE_ZAJAVLS = 'ALLOWED_ONLINE_ZAJAVLS';
export const LOADED_ZAJAVLS = 'LOADED_ZAJAVLS';
export const REQUIREMENTS_DOCUMENTS_ZAJAVLS = 'REQUIREMENTS_DOCUMENTS_ZAJAVLS';
export const TEMPLATES_DOCUMENTS_ZAJAVLS = 'TEMPLATES_DOCUMENTS_ZAJAVLS';
export const HISTORY_ZAJAVL = 'HISTORY_ZAJAVL';
export const LOADING_HISTORY_ZAJAVL = 'LOADING_HISTORY_ZAJAVL';

export const COMMENTS_ZAJAVLS = 'COMMENTS_ZAJAVLS';

export const LOADING_APPLICATION = 'LOADING_APPLICATION';
export const NOTIFICATIONS_APPLICATION = 'NOTIFICATIONS_APPLICATION';

export const FILES_INFO_RECEIVED = 'FILES_INFO_RECEIVED';
export const ZAJAVLS_CONSENT_OR_REFUSAL_PAGE_LOADED = 'ZAJAVLS_CONSENT_OR_REFUSAL_PAGE_LOADED';

export const SETTINGS_PAGE_LOADED = 'SETTINGS_PAGE_LOADED';
export const SET_TWO_FACTOR_LOGIN = 'SET_TWO_FACTOR_LOGIN';

export const OPEN_WRONG_PAGE = 'OPEN_WRONG_PAGE';

export const SET_EXAMS = 'SET_EXAMS';
export const OPEN_EXAM_EDIT = 'OPEN_EXAM_EDIT';
export const CLOSE_EXAM_EDIT = 'CLOSE_EXAM_EDIT';
export const SET_EXAM_EDIT = 'SET_EXAM_EDIT';
export const RESET_EXAM_EDIT = 'RESET_EXAM_EDIT';
export const SET_APPLICANT_EXAMS = 'SET_APPLICANT_EXAMS';
export const OPEN_EXAM_DELETE = 'OPEN_EXAM_DELETE';
export const CLOSE_EXAM_DELETE = 'CLOSE_EXAM_DELETE';
export const SET_EXAM_DELETE = 'SET_EXAM_DELETE';
export const RESET_EXAM_DELETE = 'RESET_EXAM_DELETE';

export const SET_CAPTCHA_KEY = 'SET_CAPTCHA_KEY';
export const SET_CAPTCHA_IMG = 'SET_CAPTCHA_IMG';

export const SET_LOADING_RATING_APPLICANTS = 'SET_LOADING_RATING_APPLICANTS';
export const SET_LOADED_RATING_APPLICANTS = 'SET_LOADED_RATING_APPLICANTS';

export const SET_RATING_APPLICANTS_LINKS = 'SET_RATING_APPLICANTS_LINKS';
